import React from 'react';
import * as settings from '../../settings';

import styles from './Loading.scss';

const LoadingGraphic = () => (
  <div className="Loading">
    <div className="Loading__content">
      <img
        src={`${settings.ASSETS_URL}/img/loading.gif`}
        alt="spinning squares"
      />
      <p>Loading</p>
    </div>
  </div>
);

const Loading = ({ showText = true, fullPage = true }) => {
  if (fullPage) {
    return (
      <main>
        <div className="Page__container">
          <LoadingGraphic />
        </div>
      </main>
    );
  } else {
    return <LoadingGraphic />;
  }
};

export default Loading;
